import styled from 'styled-components';

import { getorientation } from '~/utils/style-utils';

export const Wrapper = styled.div`
	background-color: rgba(0, 0, 0, 0.4);
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	height: 100%;

	${getorientation.landscape`
		max-width:  350px;
		margin: auto;
	`}
`;

export const Content = styled.div`
	align-items: center;
	background-color: var(--new-qd--modal-bg, var(--quick-deposit-modal-bg));
	border-radius: 12px 12px 0 0;
	bottom: 0;
	display: flex;
	flex-direction: column;
	gap: 18px;
	margin: 0 24px;
	min-width: 280px;
	padding: 24px;
	width: 100%;

	${getorientation.landscape`
		margin:  0;
		padding: 10px 20px;
	`}
`;

export const NewQDLogoContainer = styled.div`
	padding: 0 3px;
	background: #ffffff;
	border-radius: 6px;
	border: 1px solid rgba(232, 234, 236, 1);

	svg {
		height: 31px;
		width: 57px;
	}
`;
